import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { OpenFeatureModule } from '@openfeature/angular-sdk';
import { FlagsmithClientProvider } from '@openfeature/flagsmith-client-provider';
import { ComponentsModule } from 'shared/components/components.module';
import { AppTranslateModule } from './app-translation.module';
import { flagsmith } from '../config';
import { providers } from './providers/app.providers';

@NgModule({
    imports: [
        OpenFeatureModule.forRoot({
            provider: new FlagsmithClientProvider({
                environmentID: flagsmith.environmentID,
                api: flagsmith.api,
                fetch: function timeoutFetch(...args: Parameters<typeof fetch>) {
                    const [input, init = {}] = args;
                    const controller = new AbortController();
                    const timeoutId = setTimeout(() => controller.abort('Timeout'), 5000);
                    return fetch(input, { ...init, signal: controller.signal }).finally(() => clearTimeout(timeoutId));
                }
            })
        }),
        AppTranslateModule,
        ComponentsModule
    ],
    providers: [...providers, provideHttpClient(withInterceptorsFromDi())]
})
export class CoreModule {}
